import { Info } from "lucide-react";
import { PASSWORD_REQUIREMENTS_TEXT } from "@/utils/passwordValidation";

/**
 * パスワード要件のヒント表示。
 * NewPasswordUI / ResetPasswordUI / ChangePasswordPage で共通利用する。
 */
export const PasswordRequirementsHint: React.FC = () => (
  <div className="flex items-start gap-2">
    <Info size={14} className="text-neutral-500 mt-0.5 flex-shrink-0" />
    <p className="text-xs text-neutral-500 leading-relaxed">
      {PASSWORD_REQUIREMENTS_TEXT}
    </p>
  </div>
);
